import baseFilters, { baseTagFilter } from '@/app/dashboard/filters';
import { Icons } from '@/components/icons';
import {
  defaultEnumFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  InspectionErrandProtocolSettingConfig,
  InspectionErrandSettingConfig,
  RealEstateConfig,
} from '@pigello/pigello-matrix';

const inspectionErrandSettingFilters: Filter[] = [
  {
    ...defaultEnumFilter,
    title: InspectionErrandSettingConfig.fields.isActive.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.isActive.externalFieldName,
    enumChoices: [
      {
        filters: [{ operator: 'noop', value: 'true' }],
        title: 'Aktiv',
        badgeVariant: 'green',
      },
      {
        filters: [{ operator: 'noop', value: 'false' }],
        title: 'Inaktiv',
        badgeVariant: 'destructive',
      },
    ],
  },
  {
    ...defaultStringFilter,
    title: InspectionErrandSettingConfig.fields.name.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.name.externalFieldName,
  },
  {
    ...defaultRelationFilter,
    title: InspectionErrandSettingConfig.fields.realestates.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.realestates.externalFieldName,
    relationModelName: RealEstateConfig.modelName,
    icon: Icons.realestate,
  },
  {
    ...defaultRelationFilter,
    title: InspectionErrandSettingConfig.fields.protocolSetting.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.protocolSetting.externalFieldName,
    relationModelName: InspectionErrandProtocolSettingConfig.modelName,
  },
  {
    ...defaultSelectFilter,
    title: InspectionErrandSettingConfig.fields.apartmentCategories.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.apartmentCategories
        .externalFieldName,
    choices: InspectionErrandSettingConfig.fields.apartmentCategories.choices,
  },
  {
    ...defaultSelectFilter,
    title:
      InspectionErrandSettingConfig.fields.industrialPremisesCategories
        .verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.industrialPremisesCategories
        .externalFieldName,
    choices:
      InspectionErrandSettingConfig.fields.industrialPremisesCategories.choices,
  },
  {
    ...defaultSelectFilter,
    title:
      InspectionErrandSettingConfig.fields.outdoorSectionCategories.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.outdoorSectionCategories
        .externalFieldName,
    choices:
      InspectionErrandSettingConfig.fields.outdoorSectionCategories.choices,
  },
  {
    ...defaultSelectFilter,
    title:
      InspectionErrandSettingConfig.fields.parkingSpotCategories.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.parkingSpotCategories
        .externalFieldName,
    choices: InspectionErrandSettingConfig.fields.parkingSpotCategories.choices,
  },
  {
    ...defaultSelectFilter,
    title:
      InspectionErrandSettingConfig.fields.brfApartmentCategories.verboseName,
    externalFieldName:
      InspectionErrandSettingConfig.fields.brfApartmentCategories
        .externalFieldName,
    choices:
      InspectionErrandSettingConfig.fields.brfApartmentCategories.choices,
  },
  ...baseTagFilter,
  ...baseFilters,
];

export default inspectionErrandSettingFilters;
